<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="交流活动概况" name="config">
        <!-- 活动类型 -->
        <p class="title">
          交流活动概况
          <el-button
            style="margin-left: 20px"
            type="text"
            @click="addActivityType"
            >添加交流活动</el-button
          >
        </p>
        <div class="formBox">
          <el-form
            v-for="(activityItem, activityIndex) in formData.activity_type"
            :ref="`refForm${activityIndex}`"
            :key="activityIndex"
            :model="activityItem"
            :inline="true"
            :rules="rules"
          >
            <el-form-item
              label-width="120px"
              label="活动名称："
              prop="activity_name"
            >
              <el-input
                v-model="activityItem.activity_name"
                style="width: 207px; float: left"
                placeholder="请输入活动名称"
              ></el-input>
            </el-form-item>
            <el-form-item label-width="120px" label="数量" prop="nums">
              <el-input
                type="number"
                min="0"
                class="numInput"
                v-model="activityItem.nums"
                style="width: 207px; float: left"
                placeholder="请输入数量"
              ></el-input>
              <i
                v-if="activityIndex != 0"
                @click="delActivityType(activityIndex)"
                style="margin-left: 15px; font-size: 20px"
                class="el-icon-delete"
              ></i>
            </el-form-item>
          </el-form>
        </div>

        <el-form>
          <el-form-item>
            <el-button type="primary" @click="infoSubmit()">保存</el-button>
            <el-button @click="getInfo()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="运营成绩" name="performance">
        <!-- 重要资质 -->
        <p class="title">
          重要资质
          <el-button
            style="margin-left: 20px"
            type="text"
            @click="addPerformance"
            >添加重要资质</el-button
          >
        </p>
        <div class="formBox">
          <el-form
            v-for="(activityItem, activityIndex) in cjForm.performance"
            :ref="`refForm${activityIndex}`"
            :key="activityIndex"
            :model="activityItem"
            :inline="true"
            :rules="rules"
          >
            <el-form-item label-width="120px" label="企业名称：" prop="company">
              <el-input
                v-model="activityItem.company"
                style="width: 207px; float: left"
                placeholder="请输入活动名称"
              ></el-input>
            </el-form-item>
            <el-form-item label-width="120px" label="文案" prop="value">
              <el-input
                type="textarea"
                class="numInput"
                v-model="activityItem.value"
                style="width: 207px; float: left"
                placeholder="请输入文案"
              ></el-input>
              <i
                v-if="activityIndex != 0"
                @click="delPerformance(activityIndex)"
                style="margin-left: 15px; font-size: 20px"
                class="el-icon-delete"
              ></i>
            </el-form-item>
          </el-form>
        </div>
        <!-- 重要奖项 -->
        <p class="title">
          重要奖项
          <el-button style="margin-left: 20px" type="text" @click="addAwards"
            >添加重要奖项</el-button
          >
        </p>
        <div class="formBox">
          <el-form
            v-for="(activityItem, activityIndex) in cjForm.awards"
            :ref="`refForm${activityIndex}`"
            :key="activityIndex"
            :model="activityItem"
            :inline="true"
            :rules="rules"
          >
            <el-form-item label-width="120px" label="企业名称：" prop="company">
              <el-input
                v-model="activityItem.company"
                style="width: 207px; float: left"
                placeholder="请输入企业名称"
              ></el-input>
            </el-form-item>
            <el-form-item label-width="120px" label="文案" prop="value">
              <el-input
              type="textarea"
                class="numInput"
                v-model="activityItem.value"
                style="width: 207px; float: left"
                placeholder="请输入文案"
              ></el-input>
              <i
                v-if="activityIndex != 0"
                @click="delAwards(activityIndex)"
                style="margin-left: 15px; font-size: 20px"
                class="el-icon-delete"
              ></i>
            </el-form-item>
          </el-form>
        </div>
        <!-- 重点成果 -->
        <p class="title">
          重点成果
          <el-button style="margin-left: 20px" type="text" @click="addResult"
            >添加重点成果</el-button
          >
        </p>
        <div class="formBox">
          <el-form
            v-for="(activityItem, activityIndex) in cjForm.result"
            :ref="`refForm${activityIndex}`"
            :key="activityIndex"
            :model="activityItem"
            :inline="true"
            :rules="rules"
          >
            <el-form-item label-width="120px" label="企业名称：" prop="company">
              <el-input
                v-model="activityItem.company"
                style="width: 207px; float: left"
                placeholder="请输入企业名称"
              ></el-input>
            </el-form-item>
            <el-form-item label-width="120px" label="文案" prop="value">
              <el-input
              type="textarea"
                class="numInput"
                v-model="activityItem.value"
                style="width: 207px; float: left"
                placeholder="请输入文案"
              ></el-input>
              <i
                v-if="activityIndex != 0"
                @click="delResult(activityIndex)"
                style="margin-left: 15px; font-size: 20px"
                class="el-icon-delete"
              ></i>
            </el-form-item>
          </el-form>
        </div>

        <el-form>
          <el-form-item>
            <el-button type="primary" @click="cjSubmit()">保存</el-button>
            <el-button @click="getCj()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- <el-tab-pane label="活动展示" name="activity">
        <el-button size="small" type="primary" @click="activityAdd()"
          >添加</el-button
        >
        <el-table
          :data="activityData"
          border
          stripe
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column prop="id" label="ID" width="100"> </el-table-column>
          <el-table-column label="活动性质" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.nature }}</span>
            </template>
          </el-table-column>
          <el-table-column label="活动地点" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.location }}</span>
            </template>
          </el-table-column>
          <el-table-column label="活动图片" min-width="200">
            <template slot-scope="scope">
              <el-image
                style="width: 170px; height: 100px; margin: 0 5px 5px 0"
                :src="imageOss + scope.row.thumb.split(',')[0]"
                fit="contain"
                :preview-src-list="$pathDispose(scope.row.thumb.split(','))"
              >
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="活动时间" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.create_time }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="210">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="warning"
                @click="activitySee(scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="success"
                @click="activityEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="activityDel(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="activityPage"
            :page-sizes="[15, 30, 50, 100]"
            :page-size="activitySize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="activityTotal"
          >
          </el-pagination>
        </div>
      </el-tab-pane> -->
    </el-tabs>
    <!-- 重点宣传 -->
    <el-dialog
      :title="activityTitle"
      :visible.sync="activityFormVisible"
      width="800px"
      @click="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="80px"
        :model="activityForm"
        ref="activityForm"
        :rules="activityRules"
      >
        <el-form-item label="活动性质" prop="nature">
          <el-input
            v-model="activityForm.nature"
            auto-complete="off"
            placeholder="请输入活动性质"
            :disabled="activityCz == 'see'"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动地点" prop="location">
          <el-input
            :disabled="activityCz == 'see'"
            v-model="activityForm.location"
            auto-complete="off"
            placeholder="请输入活动地点"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动时间" prop="time">
          <el-date-picker
            :disabled="activityCz == 'see'"
            v-model="activityForm.time"
            type="datetime"
            value-format="timestamp"
            placeholder="请选择活动时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动图片" prop="thumb">
          <el-upload
            ref="upload"
            name="file[]"
            :data="{ type: 'image' }"
            :action="ossUpload"
            :file-list="fileList"
            :headers="{ token: token }"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :disabled="activityCz == 'see'"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png,.jpeg"
            :class="activityCz == 'see' ? 'hide' : ''"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="文章内容" prop="content">
          <el-input
            :disabled="activityCz == 'see'"
            v-model="activityForm.content"
            auto-complete="off"
            type="textarea"
            placeholder="请输入文章内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          v-if="activityCz == 'add'"
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="activitySubmit('activityForm')"
          >添加</el-button
        >
        <el-button
          v-if="activityCz == 'edit'"
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="activityTjEdit('activityForm')"
          >提交编辑</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  wcYYActivityAdd,
  wcYYActivityEdit,
  wcYYActivityDel,
  wcYYActivityList,
  wcYYActivityDetail,
  wcYYSummarizeEdit,
  wcYYSummarizeDetail,
  wcYYPerformanceEdit,
  wcYYPerformanceDetail
} from "@/api/wuchang";
import { delImage } from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  components: {},
  computed: {
    ...mapGetters(["imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      ossUpload: this.$store.state.ossUpload,
      loading: false, //是显示加载
      activeName: "config",
      formData: {
        activity_type: [
          {
            activity_name: "",
            nums: "",
          },
        ],
      },
      rules: {
        activity_name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        nums: [{ required: true, message: "请输入数量", trigger: "blur" }],
        company: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        value: [
          {
            required: true,
            message: "请输入文案",
            trigger: "blur",
          },
        ]
      },
      activityData: [],
      activityTitle: "添加",
      activityCz: "add",
      activityFormVisible: false,
      activityForm: {},
      activityRules: {
        nature: [
          { required: true, message: "请输入活动性质", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入文章内容", trigger: "blur" },
        ],
        location: [
          { required: true, message: "请输入活动地点", trigger: "blur" },
        ],
        time: [{ required: true, message: "请输入活动时间", trigger: "blur" }],
        thumb: [
          { required: true, message: "请选择活动图片", trigger: "change" },
        ],
      },
      activityPage: 1,
      activityTotal: 80,
      activitySize: 15,
      fileList: [],
      cjForm: {
        performance: [
          {
            company: "",
            value: "",
          },
        ],
        awards: [
          {
            company: "",
            value: "",
          },
        ],
        result: [
          {
            company: "",
            value: "",
          },
        ],
      },
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    // 获取基础信息
    getCj() {
      wcYYPerformanceDetail().then((res) => {
        if (res.data.performance) {
          this.cjForm.performance = res.data.performance
        }
        if (res.data.awards) {
          this.cjForm.awards = res.data.awards
        }
        if (res.data.result) {
          this.cjForm.result = res.data.result
        }
      });
    },
    cjSubmit() {
      var that = this;
      //用Promise.all进行全部form表单的验证
      Promise.all([
        //非数组部分的表单
        // this.validateForm("refForm"),
        // 数组部分的表单，用map返回验证函数的调用
        // 活动类型
        ...this.cjForm.performance.map((item, index) =>
          this.validateForm(`refForm${index}`)
        ),
        ...this.cjForm.awards.map((item, index) =>
          this.validateForm(`refForm${index}`)
        ),
        ...this.cjForm.result.map((item, index) =>
          this.validateForm(`refForm${index}`)
        ),
      ]).then((res) => {
        let data = {
          yunyingchengji:JSON.stringify(this.cjForm),
          // performance: JSON.stringify(this.cjForm.performance),
          // awards: JSON.stringify(this.cjForm.awards),
          // result: JSON.stringify(this.cjForm.result),
        };
        wcYYPerformanceEdit(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            that.getCj();
          }
        });
        if (res) {
          // 全部表单验证通过
        }
      });
    },


    // 添加重点成果
    addResult() {
      this.cjForm.result.push({
        company: "",
        value: "",
      });
    },
    // 删除重点成果
    delResult(index) {
      this.cjForm.result.splice(index, 1);
    },
    // 添加重要奖项
    addAwards() {
      this.cjForm.awards.push({
        company: "",
        value: "",
      });
    },
    // 删除重要奖项
    delAwards(index) {
      this.cjForm.awards.splice(index, 1);
    },

    // 添加重要资质
    addPerformance() {
      this.cjForm.performance.push({
        company: "",
        value: "",
      });
    },
    // 删除重要资质
    delPerformance(index) {
      this.cjForm.performance.splice(index, 1);
    },

    // 删除图片
    delImg(path) {
      delImage({ file: path }).then((ress) => {});
    },
    // 活动图片
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.activityForm.thumb = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 活动图片删除
    handleRemove(file) {
      if (file.response.data.url) {
        this.fileList.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.activityForm.thumb = list.join(",");
      // this.fileList = [];
      // this.activityForm.thumb = "";
    },
    // 活动图片上传限制
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传人脸图片大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // 获取重点项目宣传
    getActivityList() {
      let data = {
        page: this.activityPage,
        page_size: this.activitySize,
      };
      wcYYActivityList(data).then((res) => {
        this.activityTotal = res.data.total;
        this.activityData = res.data.data;
      });
    },
    // 重点项目分页
    handleSizeChange(val) {
      this.activitySize = val;
      this.getActivityList();
    },
    // 重点项目分页
    handleCurrentChange(val) {
      this.activityPage = val;
      this.getActivityList();
    },

    // 重点项目宣传-新增
    activitySubmit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.activityForm.activity_time = that.activityForm.time / 1000;
          wcYYActivityAdd(that.activityForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getActivityList();
              that.activityFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 重点项目宣传-编辑
    activityTjEdit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.activityForm.activity_time = that.activityForm.time / 1000;
          wcYYActivityEdit(that.activityForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              that.getActivityList();
              that.activityFormVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 重点项目宣传-删除
    activityDel(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          wcYYActivityDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.getActivityList();
          });
        })
        .catch(() => {});
    },
    // 重点项目宣传-详情
    activityInfo(id) {
      wcYYActivityDetail({ id: id }).then((res) => {
        this.activityForm = {
          id: res.data.id,
          thumb: res.data.thumb,
          time: res.data.activity_time * 1000,
          nature: res.data.nature,
          content: res.data.content,
          location: res.data.location,
        };
        this.fileList = [];
        if (res.data.thumb) {
          let list = res.data.thumb.split(",");
          list.forEach((item, index) => {
            this.fileList.push({ url: this.imageOss + item });
          });
        }
      });
    },
    // 添加重点项目宣传
    activityAdd() {
      this.activityFormVisible = true;
      this.activityTitle = "添加";
      this.activityCz = "add";
      this.activityForm = {
        thumb: "",
        time: "",
        nature: "",
        content: "",
        location: "",
      };
    },
    // 表格编辑操作
    activityEdit(val) {
      this.activityTitle = "编辑";
      this.activityCz = "edit";
      this.activityInfo(val.id);
      this.activityFormVisible = true;
    },
    // 表格查看操作
    activitySee(val) {
      this.activityTitle = "查看";
      this.activityCz = "see";
      this.activityInfo(val.id);
      this.activityFormVisible = true;
    },
    // 获取基础信息
    getInfo() {
      wcYYSummarizeDetail().then((res) => {
        this.formData.activity_type = res.data;
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.activityFormVisible = false;
    },
    infoSubmit() {
      var that = this;
      //用Promise.all进行全部form表单的验证
      Promise.all([
        //非数组部分的表单
        // this.validateForm("refForm"),
        // 数组部分的表单，用map返回验证函数的调用
        // 活动类型
        ...this.formData.activity_type.map((item, index) =>
          this.validateForm(`refForm${index}`)
        ),
      ]).then((res) => {
        let data = {
          activity_type: JSON.stringify(this.formData.activity_type),
        };
        wcYYSummarizeEdit(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            that.getInfo();
          }
        });
        if (res) {
          // 全部表单验证通过
        }
      });
    },
    validateForm(refs) {
      //获取到form表单的dom，如果是对象直接拿到，如果是数组，就拿第一个
      //elementui对循环的form包装成了数组
      let valiForm = this.$refs?.[refs].validate
        ? this.$refs?.[refs]
        : this.$refs?.[refs][0];
      return new Promise((resolve, reject) => {
        //在Promise里进行验证，如果通过就resolve()
        valiForm.validate((res) => {
          if (res) resolve();
          else reject();
        });
      });
    },
    // 添加活动类型
    addActivityType() {
      this.formData.activity_type.push({
        activity_name: "",
        nums: "",
      });
    },
    // 删除活动类型
    delActivityType(index) {
      this.formData.activity_type.splice(index, 1);
    },
    // 添加园区行业类型统计
    addParkTypes() {
      this.formData.park_types.push({
        type_name: "",
        nums: "",
      });
    },
    // 删除园区行业类型统计
    delParkTypes(index) {
      this.formData.park_types.splice(index, 1);
    },
    // 添加自营农业商品种类概括
    addProduct() {
      this.formData.product_types.push({
        product_name: "",
        nums: "",
      });
    },
    // 删除自营农业商品种类概括
    delProduct(index) {
      this.formData.product_types.splice(index, 1);
    },
    handleClick(tab, event) {
      if (tab.index == 0) {
        this.getInfo();
      } else if (tab.index == 1) {
        this.getCj()
      } else if (tab.index == 2) {
        this.getActivityList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
}
.info {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  padding: 20px;
}

.box-card {
  width: 300px;
  height: 100px;
  display: inline-block;
  margin: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  text-align: center;
  line-height: 100px;
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
.title {
  font-size: 16px;
  font-weight: 600;
}
.formBox {
  width: 100%;
  max-height: 300px;
  overflow: auto;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
